package one.healthium.ui.compose.components

import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.staticCompositionLocalOf

@Composable
fun AppGlobalProgressIndicator(content: @Composable () -> Unit) {
    val visible = remember { mutableStateOf(false) }

    CompositionLocalProvider(LocalGlobalProgressIndicator provides visible) {
        Box {
            content()
            AppLoadingScreen(
                visible = visible.value,
                dim = true
            )
        }
    }
}

val LocalGlobalProgressIndicator = staticCompositionLocalOf<MutableState<Boolean>> { error("No AppShapes provided") }
